<template>
<div>
    <Breadcrumbs main="CRM" title="Deal Room" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                 
                        <!-- Summary Widgets -->
                        <div class="row">
                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 mt-4 mt-md-2 mt-lg-4 mt-xl-0">
                             
                                    <div class="card small-widget">
                                        <div class="card-body success"><span class="f-light">Open Deals</span>
                                            <div class="d-flex gap-1 align-items-end">
                                                <h4>{{ stats?.open_deals ?? 'N/A' }}</h4>
                                            </div>
                                            <div class="bg-gradient">
                                                <svg class="stroke-icon svg-fill" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px">
                                                    <g id="SVGRepo_iconCarrier">
                                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.25 6C3.25 4.45831 4.48029 3.26447 6.00774 2.50075C7.58004 1.7146 9.69967 1.25 12 1.25C14.3003 1.25 16.42 1.7146 17.9923 2.50075C19.5197 3.26447 20.75 4.45831 20.75 6V18C20.75 19.5417 19.5197 20.7355 17.9923 21.4992C16.42 22.2854 14.3003 22.75 12 22.75C9.69967 22.75 7.58004 22.2854 6.00774 21.4992C4.48029 20.7355 3.25 19.5417 3.25 18V6ZM4.75 6C4.75 5.33255 5.31057 4.52639 6.67856 3.84239C8.00168 3.18083 9.88205 2.75 12 2.75C14.118 2.75 15.9983 3.18083 17.3214 3.84239C18.6894 4.52639 19.25 5.33255 19.25 6C19.25 6.66745 18.6894 7.47361 17.3214 8.15761C15.9983 8.81917 14.118 9.25 12 9.25C9.88205 9.25 8.00168 8.81917 6.67856 8.15761C5.31057 7.47361 4.75 6.66745 4.75 6ZM4.75 18C4.75 18.6674 5.31057 19.4736 6.67856 20.1576C8.00168 20.8192 9.88205 21.25 12 21.25C14.118 21.25 15.9983 20.8192 17.3214 20.1576C18.6894 19.4736 19.25 18.6674 19.25 18V14.7072C18.8733 15.0077 18.4459 15.2724 17.9923 15.4992C16.42 16.2854 14.3003 16.75 12 16.75C9.69967 16.75 7.58004 16.2854 6.00774 15.4992C5.55414 15.2724 5.12675 15.0077 4.75 14.7072V18ZM19.25 8.70722V12C19.25 12.6674 18.6894 13.4736 17.3214 14.1576C15.9983 14.8192 14.118 15.25 12 15.25C9.88205 15.25 8.00168 14.8192 6.67856 14.1576C5.31057 13.4736 4.75 12.6674 4.75 12V8.70722C5.12675 9.00772 5.55414 9.27245 6.00774 9.49925C7.58004 10.2854 9.69967 10.75 12 10.75C14.3003 10.75 16.42 10.2854 17.9923 9.49925C18.4459 9.27245 18.8733 9.00772 19.25 8.70722Z"></path>
                                                    </g>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                            </div>

                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 mt-4 mt-md-2 mt-lg-4 mt-xl-0">
                              
                                    <div class="card small-widget">
                                        <div class="card-body success"><span class="f-light">Weighted Pipeline</span>
                                            <div class="d-flex gap-1 align-items-end">
                                                <h4>{{ formatM(stats?.weighted_pipeline) }}</h4>
                                            </div>
                                            <div class="bg-gradient">
                                                <svg class="stroke-icon svg-fill" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px">
                                                    <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
                                                    <path d="M12.5 6.5h-1v1.26C10.06 8.08 9 9.17 9 10.5c0 1.66 1.34 2.5 3 2.5.83 0 1.5.45 1.5 1s-.67 1-1.5 1S10.5 14.55 10.5 14H9c0 1.33 1.06 2.42 2.5 2.74V18h1v-1.26c1.44-.32 2.5-1.41 2.5-2.74 0-1.66-1.34-2.5-3-2.5-.83 0-1.5-.45-1.5-1s.67-1 1.5-1 1.5.45 1.5 1H15c0-1.33-1.06-2.42-2.5-2.74V6.5z"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                               
                            </div>

                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 mt-4 mt-md-2 mt-lg-4 mt-xl-0">
                              
                                    <div class="card small-widget">
                                        <div class="card-body success"><span class="f-light">Sales Cycle</span>
                                            <div class="d-flex gap-1 align-items-end">
                                                <h4>{{ formatDay(stats?.sales_cycle_days) }}</h4>
                                            </div>
                                           <div class="bg-gradient">
                                                <svg class="stroke-icon svg-fill" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px">
                                                    <path d="M9 1h6v2H9zM11 14h2V9h-2zM12 3C7.03 3 3 7.03 3 12s4.03 9 9 9 9-4.03 9-9-4.03-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z"/>
                                                    <path d="M18.29 4.29l1.42 1.42-1.77 1.77-1.41-1.41z"/>
                                                </svg>
                                            </div>
                                        </div>
                                    </div>
                                
                            </div>

                            <div class="col-xl-3 col-lg-6 col-md-6 col-sm-6 mt-4 mt-md-2 mt-lg-4 mt-xl-0">
                                
                                    <div class="card small-widget">
                                        <div class="card-body success"><span class="f-light">Closing This Month</span>
                                            <div class="d-flex gap-1 align-items-end">
                                                <h4>{{ formatM(stats?.closing_this_month) }}</h4>
                                            </div>
                                            <div class="bg-gradient">
                                                    <svg class="stroke-icon svg-fill" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" width="30px" height="30px">
                                                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z"/>
                                                        <path d="M10 14.17l-2.59-2.58L6 13l4 4 8-8-1.41-1.42z"/>
                                                    </svg>
                                                </div>
                                            </div>
                                    </div>
                               
                            </div>
                        </div>

                        <!-- Kanban Board -->
                        <div class="mt-4 kanban-board" v-if="deals">
                            <div
                                v-for="stage in stages"
                                :key="stage.key"
                                class="kanban-col"
                                :class="`stage-${stage.key}`"
                            >
                                <!-- Column Header -->
                                <div class="kanban-col-header">
                                    <div class="d-flex gap-2 align-items-center">
                                        <span class="stage-dot"></span>
                                        <span class="stage-label ml-2">{{ stage.label }}</span>
                                    </div>
                                    <span class="badge stage-badge">{{ stage.count }}</span>
                                </div>

                                <!-- Cards -->
                                <div class="kanban-col-body">
                                    <div v-if="stage.leads.length === 0" class="kanban-empty">
                                        No leads
                                    </div>
                                    <div
                                        v-for="(lead, i) in stage.leads"
                                        :key="lead.id"
                                        class="kanban-card"
                                        :style="{ animationDelay: i * 0.07 + 's' }"
                                    >
                                        <router-link :to="`/crm/lead/details/${lead.id}`" class="text-decoration-none">
                                            <div class="kanban-card-accent"></div>
                                            <div class="d-flex mb-1 justify-content-between align-items-start">
                                                <span class="lead-name">{{ formatName(lead.lead_name) }}</span>
                                                <!-- <span class="lead-id">#{{ lead.id }}</span> -->
                                            </div>
                                            <div class="lead-company">
                                                <i v-if="lead.company_name">{{ lead.company_name }}</i>
                                                <i v-else class="text-muted">No company</i>
                                            </div>
                                            <div v-if="lead.next_action" class="mt-1 lead-action">
                                                → {{ lead.next_action }}
                                            </div>
                                            <div class="d-flex justify-content-between align-items-center kanban-card-footer">
                                                <span class="lead-value">৳{{ (lead.pipeline_value || 0).toLocaleString() }}</span>
                                                <span class="badge bg-success-subtle text-success lead-status">{{ lead.status }}</span>
                                            </div>
                                        </router-link>
                                    </div>
                                </div>

                                <!-- Column Footer -->
                                <div class="kanban-col-footer">
                                    Total: ৳{{ stage.total_value.toLocaleString() }}
                                </div>
                            </div>
                        </div>

                        <!-- Loading state -->
                        <div v-else class="py-5 text-center text-muted">
                            <div class="me-2 spinner-border spinner-border-sm"></div>
                            Loading pipeline...
                        </div>

                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->
</div>
</template>

<script>
import { mapState } from 'vuex';

const STAGE_ORDER  = ['qualified', 'discovery', 'demo', 'proposal', 'trial'];
const STAGE_LABELS = {
    qualified: 'Qualified',
    discovery: 'Discovery',
    demo:      'Demo',
    proposal:  'Proposal',
    trial:     'Trial',
};

export default {
    data() {
        return {};
    },

    computed: {
        ...mapState({
            deals: state => state.client.dealroom,
            stats: state => state.client.dealroom_stats,
        }),

        stages() {
            if (!this.deals) return [];
            return STAGE_ORDER.map(key => ({
                key,
                label: STAGE_LABELS[key],
                ...(this.deals[key] || { count: 0, total_value: 0, leads: [] }),
            }));
        },

        totalValue() {
            if (!this.deals) return 0;
            return STAGE_ORDER.reduce((sum, key) => sum + (this.deals[key]?.total_value || 0), 0);
        },
    },

    mounted() {
        this.$store.dispatch('client/fetchDealRoomKanban');
        this.$store.dispatch('client/fetchDealRoomStats');

    },

    methods: {
        formatName(raw) {
            if (!raw) return 'Unnamed Lead';
            return raw.replace(/\s+None\s*$/i, '').trim() || 'Unnamed Lead';
        },

        // FIXED: 0 is falsy — use null/undefined check instead
        formatM(value) {
            if (value === null || value === undefined) return 'N/A';
            if (value === 0) return '৳ 0';
            if (value >= 1_000_000) return '৳ ' + (value / 1_000_000).toFixed(1) + 'M';
            if (value >= 1_000)    return '৳ ' + (value / 1_000).toFixed(1) + 'K';
            return '৳ ' + value.toLocaleString();
        },

        // FIXED: 0 is falsy — use null/undefined check instead
        formatDay(value) {
            if (value === null || value === undefined) return 'N/A';
            if (value === 0) return '0d';
            return value + 'd';
        },
    },
};
</script>

<style scoped>
* { box-sizing: border-box; }

/* ── Existing widget styles (unchanged) ─────────────────────────────────── */
.small-widget { overflow: hidden; }
.warning .bg-gradient  { background-image: linear-gradient(144.16deg, rgba(255,170,5,.1) 19.06%, rgba(255,170,5,0) 79.03%) !important; }
.success .bg-gradient  { background-image: linear-gradient(144.16deg, rgba(84,186,74,.1) 19.06%, rgba(84,186,74,0) 79.03%) !important; }
.secondary .bg-gradient{ background-image: linear-gradient(144.16deg, rgba(255,51,100,.1) 19.06%, rgba(255,51,100,0) 79.03%) !important; }
.secondary .svg-fill   { fill: #F73A6A; }
.success .svg-fill     { fill: #54ba4a; }
.warning .svg-fill     { fill: #ffaa05; }
.primary .svg-fill     { fill: #7366ff; }
.small-widget .bg-profile    { width:125px; height:130px; display:flex; align-items:center; justify-content:center; border-radius:100px; left:-12px; top:50%; position:absolute; transform:translateY(-50%); }
.small-widget .profile-info  { display:flex; flex-direction:column; top:50%; position:absolute; transform:translateY(-50%); }
.small-widget .bg-gradient   { width:66px; height:67px; display:flex; align-items:center; justify-content:center; border-radius:100px; right:-12px; top:50%; position:absolute; transform:translateY(-50%); }

/* ── Kanban board ────────────────────────────────────────────────────────── */
.kanban-board {
    display: flex;
    gap: 1rem;
    overflow-x: auto;
    padding-bottom: 1rem;
    align-items: flex-start;
}

.kanban-col {
    flex: 0 0 286px;
    background: var(--bs-body-bg, #f8f9fa);
    border: 1px solid var(--bs-border-color, #dee2e6);
    border-radius: 12px;
    overflow: hidden;
}

/* ── Column header ───────────────────────────────────────────────────────── */
.kanban-col-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0.65rem 0.875rem;
    border-bottom: 1px solid var(--bs-border-color, #dee2e6);
}
.stage-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
}
.stage-label {
    font-size: 0.75rem;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: 0.07em;
}
.stage-badge {
    font-size: 0.8rem;
    padding: 4px 10px;
    border-radius: 20px;
    background: var(--bs-secondary-bg, #bebfc050);
    color: var(--bs-secondary-color, #3d4347);
    font-weight: 600;
}

/* ── Per-stage colors ────────────────────────────────────────────────────── */
/* qualified — blue */
.stage-qualified .kanban-col-header { background: rgba(59, 131, 246, 0.116); }
.stage-qualified .stage-dot         { background: #3b82f6; box-shadow: 0 0 5px #3b82f6; }
.stage-qualified .stage-label       { color: #3b82f6; }
.stage-qualified .kanban-card-accent{ background: #3b82f6; }
 
/* discovery — purple */
.stage-discovery .kanban-col-header { background: rgba(139,92,246,0.08); }
.stage-discovery .stage-dot         { background: #8b5cf6; box-shadow: 0 0 5px #8b5cf6; }
.stage-discovery .stage-label       { color: #8b5cf6; }
.stage-discovery .kanban-card-accent{ background: #8b5cf6; }
 
/* demo — #cffafe */
.stage-demo .kanban-col-header      { background: rgba(207, 250, 254, 0.404); }
.stage-demo .stage-dot              { background: #02e8fd; box-shadow: 0 0 5px #02e8fd; }
.stage-demo .stage-label            { color: #02e8fd; }
.stage-demo .kanban-card-accent     { background: #02e8fd; }
 
/* proposal — orange */
.stage-proposal .kanban-col-header  { background: rgba(249,115,22,0.08); }
.stage-proposal .stage-dot          { background: #f97316; box-shadow: 0 0 5px #f97316; }
.stage-proposal .stage-label        { color: #f97316; }
.stage-proposal .kanban-card-accent { background: #f97316; }
 
/* trial — rose (unchanged) */
.stage-trial .kanban-col-header     { background: rgba(251,113,133,0.08); }
.stage-trial .stage-dot             { background: #fb7185; box-shadow: 0 0 5px #fb7185; }
.stage-trial .stage-label           { color: #fb7185; }
.stage-trial .kanban-card-accent    { background: #fb7185; }

/* ── Column body ─────────────────────────────────────────────────────────── */
.kanban-col-body {
    padding: 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
    min-height: 60px;
}

/* ── Card ────────────────────────────────────────────────────────────────── */
.kanban-card {
    background: #fff;
    border: 1px solid var(--bs-border-color, #dee2e6);
    border-radius: 8px;
    padding: 0.7rem 0.75rem 0.6rem;
    cursor: pointer;
    transition: transform 0.15s ease, box-shadow 0.15s ease;
    animation: cardIn 0.25s ease both;
    position: relative;
    overflow: hidden;
}
.kanban-card:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 16px rgba(0,0,0,0.1);
}

@keyframes cardIn {
    from { opacity: 0; transform: translateY(8px); }
    to   { opacity: 1; transform: translateY(0); }
}

.kanban-card-accent {
    height: 3px;
    border-radius: 2px;
    margin-bottom: 0.55rem;
}

.lead-name {
    font-size: 0.8rem;
    font-weight: 600;
    color: var(--bs-body-color, #212529);
    line-height: 1.3;
    word-break: break-word;
}
.lead-id {
    font-size: 0.65rem;
    color: var(--bs-secondary-color, #6c757d);
    white-space: nowrap;
    margin-left: 4px;
    margin-top: 1px;
}
.lead-company {
    font-size: 0.7rem;
    color: var(--bs-secondary-color, #6c757d);
    margin-bottom: 0.2rem;
}
.lead-action {
    font-size: 0.68rem;
    color: var(--bs-secondary-color, #6c757d);
}
.kanban-card-footer {
    margin-top: 0.5rem;
    padding-top: 0.4rem;
    border-top: 1px solid var(--bs-border-color, #dee2e6);
}
.lead-value {
    font-size: 0.7rem;
    color: var(--bs-secondary-color, #6c757d);
    font-weight: 500;
}
.lead-status {
    font-size: 0.6rem;
    padding: 2px 6px;
}

/* ── Column footer ───────────────────────────────────────────────────────── */
.kanban-col-footer {
    padding: 0.4rem 0.875rem 0.55rem;
    font-size: 0.68rem;
    color: var(--bs-secondary-color, #6c757d);
    border-top: 1px solid var(--bs-border-color, #dee2e6);
}

/* ── Empty state ─────────────────────────────────────────────────────────── */
.kanban-empty {
    text-align: center;
    padding: 1.25rem 0;
    font-size: 0.72rem;
    color: var(--bs-secondary-color, #6c757d);
    font-style: italic;
}
</style>